import { switchMap, map } from 'rxjs/operators';
import { Fetch } from '@app/models/fetch';
import { AuthState } from '@app/auth/auth.state';
import { WaterStatus, ActiveLeak } from '@app/models/water-status/water-status.model';
import { Subject, BehaviorSubject, Observable, pipe } from 'rxjs';
import { UnitService } from '@app/utils/unit.service';
import { DateTime } from 'luxon';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../../auth/auth.state";
import * as i3 from "../../utils/unit.service";
var WaterStatusService = /** @class */ (function () {
    function WaterStatusService(fetch, authState, units) {
        this.fetch = fetch;
        this.authState = authState;
        this.units = units;
        this._activeLeak = new BehaviorSubject(null);
        this.activeLeak = this._activeLeak.asObservable(); // eslint-disable-line
        this._scrollToLeak = new BehaviorSubject(null);
        this.scrollToLeak = this._scrollToLeak.asObservable(); // eslint-disable-line
    }
    WaterStatusService.prototype.getWaterStatusPipe = function () {
        var _this = this;
        return pipe(switchMap(function (loc) { return _this.getWaterStatus(loc.ws.id, _this.units.get().query); }));
    };
    WaterStatusService.prototype.getWaterStatus = function (deviceID, units) {
        return this.fetch
            .getAll("//users/" + this.authState.userID() + "/devices/" + deviceID + "/query/active")
            .req.pipe();
    };
    WaterStatusService.prototype.getLeakStatusPipe = function () {
        var _this = this;
        return pipe(switchMap(function (loc) { return _this.getLeakStatus(loc.ws.id); }));
    };
    WaterStatusService.prototype.getLeakStatus = function (deviceID) {
        return this.fetch
            .getAll("//users/" + this.authState.userID() + "/devices/" + deviceID + "/leaks/active")
            .req.pipe(map(function (res) {
            res.data[0].device_id = deviceID;
            return res;
        }));
    };
    WaterStatusService.prototype.getActiveLeak = function (deviceID, leakID) {
        var _this = this;
        this.fetch
            .getAll("//users/" + this.authState.userID() + "/devices/" + deviceID + "/leaks/" + leakID)
            .model(ActiveLeak)
            .subscribe(function (data) {
            _this._activeLeak.next(data);
        });
    };
    WaterStatusService.prototype.removeLeak = function () {
        this._activeLeak.next(null);
    };
    WaterStatusService.prototype.buildLeakDisplayData = function (startStopString, totalGpm, totalGallons, leakDuration, leakEndDate) {
        var leakDisplayData = {
            startStopString: startStopString,
            flowRate: this.parseValueFromString(totalGpm),
            total: this.parseValueFromString(totalGallons),
            duration: leakDuration,
            durationString: leakEndDate === null ? 'This leak has been running for' : 'This leak ran for',
        };
        return leakDisplayData;
    };
    WaterStatusService.prototype.parseValueFromString = function (input) {
        var flowrate = input.split('.');
        if (flowrate[0] === '0') {
            return '.' + flowrate[1].slice(0, 2);
        }
        else {
            return flowrate[0] + '.' + flowrate[1].slice(0, 2);
        }
    };
    WaterStatusService.prototype.getStartStopString = function (leakStart, leakEnd) {
        var start = DateTime.fromISO(leakStart);
        if (leakEnd === null) {
            return "This leak started on " + start.toFormat('EEE MMM dd, yyyy') + " at " + start.toFormat('hh:mm a') + " and is currently active.";
        }
        else {
            var end = DateTime.fromISO(leakEnd);
            return "This leak ended on " + end.toFormat('EEE MMM dd, yyyy') + " at " + end.toFormat('hh:mm a');
        }
    };
    WaterStatusService.prototype.getLeakDuration = function (leakStart, leakEnd) {
        var start = DateTime.fromISO(leakStart);
        var end;
        if (leakEnd === null) {
            end = DateTime.fromJSDate(new Date());
        }
        else {
            end = DateTime.fromISO(leakEnd);
        }
        var duration = end.diff(start, ['months', 'days', 'hours', 'minutes']).normalize().toObject();
        if (duration.months > 0) {
            duration.months = duration.months.toFixed();
        }
        if (duration.days > 0) {
            duration.days = duration.days.toFixed();
        }
        if (duration.hours > 0) {
            duration.hours = duration.hours.toFixed();
        }
        if (duration.minutes > 0) {
            duration.minutes = duration.minutes.toFixed();
        }
        return duration;
    };
    WaterStatusService.prototype.triggerScrollToLeak = function () {
        this._scrollToLeak.next(true);
    };
    WaterStatusService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function WaterStatusService_Factory() { return new WaterStatusService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.AuthState), i0.ɵɵinject(i3.UnitService)); }, token: WaterStatusService, providedIn: "root" });
    return WaterStatusService;
}());
export { WaterStatusService };
